import moment from 'moment'

export function compare(property) {
  return function (a, b) {
    var value1 = a[property]
    var value2 = b[property]
    return value1 - value2
  }
}

export function getDateYMD(value) {
  return moment(value).format('YYYY-MM-DD HH:mm')
}

export function timeFormart(value) {
  return moment(value).format()
}
